var _defs, _sodipodiNamedview, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLostTimeWordmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 836.43994,
    height: 239.23102,
    id: "svg2",
    inkscapeVersion: "0.48.4 r9939",
    sodipodiDocname: "LostTimeWordmark.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("inkscapePerspective", {
    sodipodiType: "inkscape:persp3d",
    inkscapeVp_x: "27.536134 : 563.93968 : 1",
    inkscapeVp_y: "611.371 : 104.42141 : 1",
    inkscapeVp_z: "1060.1067 : 499.40186 : 1",
    "inkscapePersp3d-origin": "526.18109 : 248.03149 : 1",
    id: "perspective3833"
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 1.1324002,
    inkscapeCx: 249.72426,
    inkscapeCy: 27.824017,
    "inkscapeDocument-units": "px",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "fit-margin-top": 20,
    "fit-margin-left": 20,
    "fit-margin-right": 20,
    "fit-margin-bottom": 20
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(-106.96953,-306.02041)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 133.10101,380.52058 c 1.20593,15.96598 2.65837,36.03777 0.47887,61.60138 -2.54405,29.83933 -2.10462,56.07222 1.55094,65.5899 3.65556,9.51767 20.2976,7.26396 33.37076,7.11852 21.73189,-0.24179 43.20322,-2.88557 43.20322,-2.88557",
    id: "path2985",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cszsc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiType: "arc",
    style: {
      fill: "none",
      stroke: "#ff00ff",
      strokeWidth: 3.23421383,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    id: "path2987",
    sodipodiCx: 289.12943,
    sodipodiCy: 417.31009,
    sodipodiRx: 18.931093,
    sodipodiRy: 18.931093,
    d: "m 308.06052,417.31009 c 0,10.45535 -8.47574,18.93109 -18.93109,18.93109 -10.45536,0 -18.9311,-8.47574 -18.9311,-18.93109 0,-10.45535 8.47574,-18.93109 18.9311,-18.93109 10.45535,0 18.93109,8.47574 18.93109,18.93109 z",
    transform: "matrix(1.5447392,0,0,1.5472033,-184.00964,-159.86887)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 356.21028,459.39002 c -31.11645,0 -49.23834,7.34507 -40.85735,16.78873 8.381,9.44366 37.71447,8.39437 39.80972,19.93662 2.09524,11.54224 -6.16205,21.05639 -20.69057,19.41195 -14.40807,-1.63079 -23.30964,-6.55809 -23.30964,-6.55809",
    id: "path2991",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "csssc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3799",
    transform: "matrix(1.2174538,0,0,1.2193958,-94.53002,-14.32476)",
    style: {
      strokeWidth: 8.20732117,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cc",
    "inkscapeConnector-curvature": 0,
    id: "path2993",
    d: "m 389.59328,388.26806 c 27.26881,-1.6319 41.51933,-0.8605 41.51933,-0.8605",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 8.20732117,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cc",
    "inkscapeConnector-curvature": 0,
    id: "path2995",
    d: "m 410.24538,389.3437 c 0.3489,25.23624 -2.41275,34.12669 -3.22689,47.1126",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 8.20732117,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    sodipodiType: "arc",
    style: {
      fill: "none",
      stroke: "#ff00ff",
      strokeWidth: 5.23210573,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    id: "path2987-1",
    sodipodiCx: 289.12943,
    sodipodiCy: 417.31009,
    sodipodiRx: 18.931093,
    sodipodiRy: 18.931093,
    d: "m 308.06052,417.31009 c 0,10.45535 -8.47574,18.93109 -18.93109,18.93109 -10.45536,0 -18.9311,-8.47574 -18.9311,-18.93109 0,-10.45535 8.47574,-18.93109 18.9311,-18.93109 10.45535,0 18.93109,8.47574 18.93109,18.93109 z",
    transform: "matrix(0.95487694,0,0,0.9564001,-13.833466,86.30832)"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiType: "star",
    style: {
      fill: "none",
      stroke: "#ff00ff",
      strokeWidth: 10.07293129,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    id: "path3797",
    sodipodiSides: 3,
    sodipodiCx: 272.77982,
    sodipodiCy: 262.41934,
    sodipodiR1: 35.713516,
    sodipodiR2: 71.427032,
    sodipodiArg1: -3.129545,
    sodipodiArg2: -2.0823475,
    inkscapeFlatsided: "false",
    inkscapeRounded: 0,
    inkscapeRandomized: 0,
    d: "m 237.06889,261.98909 0.74522,-61.85314 53.19378,31.57195 53.19377,31.57195 -53.93899,30.28119 -53.939,30.28119 z",
    "inkscapeTransform-center-x": 14.968969,
    "inkscapeTransform-center-y": -12.054784,
    transform: "matrix(0.22696532,0.44226326,-0.43967606,0.22884711,250.62294,177.55198)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff00ff",
      strokeWidth: 5.00000048,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 213.00217,389.95836 36.43278,68.07775",
    id: "path3803",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3812",
    style: {
      strokeWidth: 10,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cc",
    "inkscapeConnector-curvature": 0,
    id: "path3001",
    d: "m 594.70523,462.3857 c -1.98506,58.42699 -3.73486,57.68405 -3.73486,57.68405",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "csssc",
    "inkscapeConnector-curvature": 0,
    id: "path3003",
    d: "m 628.1528,519.80981 c 2.29285,-50.77099 5.90691,-58.19802 15.28569,-58.34874 26.08537,-0.41923 14.52141,52.28653 16.24104,52.28654 1.58288,0 -3.07542,-52.67639 22.73746,-52.47599 13.20303,0.1025 15.59831,8.90917 15.8589,58.91708",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3803",
    style: {
      strokeWidth: 10,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 723.84046,462.23389 c -7.61937,48.25527 -4.86243,55.70599 -0.29861,55.97028 24.19166,1.40088 36.19546,-1.05067 36.19546,-1.05067",
    id: "path3005",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "csc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 721.13419,492.93325 c 19.25607,1.05066 26.32635,-0.70044 26.32635,-0.70044",
    id: "path3007",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 724.53547,463.68832 c 36.57301,-0.75399 40.21797,-1.10421 40.21797,-1.10421",
    id: "path3009",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3808",
    style: {
      strokeWidth: 10,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 497.16791,398.4559 c 74.32346,-4.45497 90.11533,-3.58388 90.11533,-3.58388",
    id: "path2993-4",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 540.21139,397.74398 c 0.95095,63.30706 0.98175,89.32304 -1.23726,121.8992",
    id: "path2995-0",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "cc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3823",
    transform: "translate(16,0)"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3968",
    d: "m 853.43968,405.83766 c -5.69407,-7.94861 -10.29705,-14.50927 -10.22886,-14.57923 0.0683,-0.0699 12.41027,4.98882 27.4268,11.24174 15.01655,6.25292 27.21142,11.39508 27.09972,11.42701 -0.16219,0.0464 -30.50086,5.73671 -33.22381,6.23148 -0.71598,0.1301 -0.79307,0.0303 -11.07385,-14.321 l 0,0 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3964",
    d: "m 814.83477,467.71231 0,-36.13377 42.72933,-7.7741 c 23.50112,-4.27574 42.75297,-7.74473 42.78187,-7.70886 0.0289,0.0359 -18.05971,18.62195 -40.19692,41.30236 -22.13721,22.68043 -41.38904,42.40962 -42.78187,43.84266 l -2.53241,2.6055 0,-36.13379 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3966",
    d: "m 826.61333,410.70215 c 5.09555,-9.98732 9.32495,-18.21548 9.39862,-18.2848 0.0737,-0.0693 0.10276,7.37775 0.0647,16.54905 l -0.0692,16.67508 -8.47951,1.46416 c -4.66372,0.8053 -8.86194,1.52968 -9.32937,1.60971 l -0.84987,0.14556 9.26466,-18.15876 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccc",
    "inkscapeConnector-curvature": 0,
    id: "path3888",
    d: "m 836.44312,386.41355 -21.20035,44.22114 89.66532,-16.43451 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3902",
    d: "m 837.8771,408.03829 c 0,-9.07245 0.0913,-16.14217 0.20707,-16.01851 0.90236,0.96468 21.49819,28.35301 21.39574,28.45209 -0.14585,0.14106 -20.50298,3.79513 -21.1812,3.802 -0.39754,0.004 -0.42161,-0.92276 -0.42161,-16.23558 z",
    style: {
      fill: "#ff8200",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path3890",
    d: "m 815.25551,430.56665 -0.0599,76.24546 89.62989,-15.45435 0.0599,-77.15099 -89.6898,92.60534",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cc",
    "inkscapeConnector-curvature": 0,
    id: "path3892",
    d: "m 837.19931,386.72323 25.70031,34.97405",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4.99999952,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3894",
    d: "m 836.85117,386.21977 0,39.46573",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3.99999976,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path3896",
    d: "m 822.47138,501.53914 c 1.52744,-1.56053 18.17748,-18.75651 37.00007,-38.21329 18.8226,-19.45678 36.43248,-37.63014 39.13306,-40.38525 l 4.91015,-5.00929 -0.12125,35.985 c -0.0667,19.79175 -0.16706,36.03117 -0.22308,36.08762 -0.10731,0.10812 -82.6568,14.37253 -83.17522,14.37253 -0.16549,0 0.94883,-1.27679 2.47627,-2.83732 z",
    style: {
      fill: "#ff5500",
      fillOpacity: 1,
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("flowRoot", {
    xmlSpace: "preserve",
    id: "flowRoot3904",
    style: {
      fontSize: 40,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      lineHeight: "125%",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      fontFamily: "Buxton Sketch",
      InkscapeFontSpecification: "Buxton Sketch"
    },
    transform: "translate(0,308.2677)"
  }, /*#__PURE__*/React.createElement("flowRegion", {
    id: "flowRegion3906"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3908",
    width: 907.8349,
    height: 341.9592,
    x: 96.138,
    y: 234.198,
    style: {
      fontSize: 40,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Buxton Sketch",
      InkscapeFontSpecification: "Buxton Sketch"
    },
    ry: 0
  })), /*#__PURE__*/React.createElement("flowPara", {
    id: "flowPara3910",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Segoe Print",
      InkscapeFontSpecification: "Segoe Print"
    }
  }, "Utilities for Orienteering"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostTimeWordmark);
export default __webpack_public_path__ + "static/media/LostTimeWordmark.2be0472c006fa1d811b9df1400dc4417.svg";
export { ForwardRef as ReactComponent };